import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">内容分类</h2>
          <p className="text-sm text-foreground-600 mt-2">探索你感兴趣的视频内容</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5 text-center hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-11 h-11 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">{cat.name}</h3>
              <p className="text-xs text-foreground-500">{cat.count} 个视频</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}